import type { ComponentProps } from "react"
import { PopoverTrigger as PopoverTriggerCore } from "@/v2-ui/popover/base/PopoverBase"

export type PopoverTriggerProps = ComponentProps<typeof PopoverTriggerCore> & {
  isToggle?: boolean
}

function PopoverTrigger(props: PopoverTriggerProps) {
  const { asChild = true, ...popoverTriggerProps } = props

  return <PopoverTriggerCore asChild={asChild} {...popoverTriggerProps} />
}

export default PopoverTrigger
